import type { JSX } from 'react';
import { useMemo } from 'react';
import { useClearFocusedAsset } from '@frameio/selection';
import { useManageGenerateTranscriptionDialog } from '@frameio/shared/hooks/useManageGenerateTranscriptionDialog';

export type GenerateTranscriptsReturn = {
  openGenerateTranscriptsDialog: (assetIds?: string[]) => void;
  generateTranscriptDialog: JSX.Element;
};

export const useGenerateTranscripts = (): GenerateTranscriptsReturn => {
  const clearFocusedAssetId = useClearFocusedAsset();

  const { createTranscriptionDialog, openGenerateTranscriptsDialog } =
    useManageGenerateTranscriptionDialog();

  const transcriptionDialog = useMemo(
    () =>
      createTranscriptionDialog({
        onClose: clearFocusedAssetId,
      }),
    [clearFocusedAssetId, createTranscriptionDialog]
  );

  return {
    openGenerateTranscriptsDialog,
    generateTranscriptDialog: transcriptionDialog,
  };
};
